// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c41df2f3","732":"53ea9680"}[chunkId] + ".chunk.js";
};